import React, { useState } from 'react';
import { giftCategories } from '../mockData';

const API_ENDPOINTS = {
  giftAddGiftsFromCatalog: 'https://gift-addgiftsfromcatalog-336444799661.us-central1.run.app/giftAddGiftsFromCatalog',
};
const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const OnboardingWizard = ({ isOpen, couple, hasGifts, onComplete, onSkip }) => {

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [itemsPerCategory, setItemsPerCategory] = useState(5);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  // ✅ Calcular el máximo disponible según las categorías seleccionadas
  const maxItemsAvailable = React.useMemo(() => {
    if (selectedCategories.length === 0) return 10;

    // Aquí deberías tener la info de cuántos items hay por categoría
    // Por ahora, asumimos un mínimo conservador
    return 10; // O podrías hacer un fetch al catálogo para saber exactamente
  }, [selectedCategories]);

  if (!isOpen || !couple) return null;
  const handleCategoryToggle = (slug) => {
    if (selectedCategories.includes(slug)) {
      setSelectedCategories(selectedCategories.filter(c => c !== slug));
    } else {
      setSelectedCategories([...selectedCategories, slug]);
    }
  };

  const handleAddGifts = () => addGiftsWith(selectedCategories, itemsPerCategory);

  const addGiftsWith = async (categories, itemsCount) => {
    if (!categories?.length) {
      alert("Seleccioná al menos una categoría");
      return;
    }

    setLoading(true);
  const start = Date.now(); // ⏱️

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(API_ENDPOINTS.giftAddGiftsFromCatalog, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          coupleId: couple.id,
          categories,
          itemsPerCategory: itemsCount,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setToast({
          title: "¡Listo!",
          message: `Agregamos ${data.giftsAdded} regalos a tu lista.`,
        }); onComplete?.();

        setSelectedCategories([]);
        setItemsPerCategory(5);

      } else {
        alert("❌ Error: " + data.error);
      }
    } catch (error) {
      console.error("Error adding gifts:", error);
      alert("❌ Error al agregar regalos");
    } finally {
      const elapsed = Date.now() - start;
    const MIN_TIME = 3000; // 👈 1 segundo (ajustable)

    if (elapsed < MIN_TIME) {
      await sleep(MIN_TIME - elapsed);
    }
    setLoading(false);
    }
  };

  const pickRandom = (arr, n) => {
    const copy = [...arr];
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy.slice(0, n);
  };

  const handleAddRandomGifts = () => {
  const randomCategoryCount = 10;

  const slugs = giftCategories.map(c => c.slug);
  const randomSlugs = pickRandom(slugs, Math.min(randomCategoryCount, slugs.length));

  const itemsCount = 10;

  setSelectedCategories(randomSlugs);
  setItemsPerCategory(itemsCount);

  addGiftsWith(randomSlugs, itemsCount);
};




  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
      }}
      // onClick={(e) => {
      //   if (e.target === e.currentTarget) onSkip?.();
      // }}
    >
      <div
        className="relative bg-white rounded-2xl shadow-2xl max-w-4xl w-full mx-4 p-4 sm:p-8 animate-scale-in max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >

       

        {/* Header (simple like GiftFormModal) */}
        <div className="flex items-start justify-between gap-4 mb-6">
          <div>
            <h3 className="text-3xl font-display font-bold text-neutral-900">
              Elegí las categorías que te interesan.
            </h3>
            <p className="text-neutral-600 mt-1">
              Después podés agregar, editar o eliminar cualquiera.
              {/* {couple.brideName} & {couple.groomName} */}
            </p>
            {/* <p className="text-neutral-600 mt-2">
            Elegí las categorías que te interesan. Después podrás agregar, editar o eliminar cualquiera.
          </p> */}
          </div>

          <button
            onClick={onSkip}
            className="text-neutral-400 hover:text-neutral-700 text-2xl leading-none"
            aria-label="Cerrar"
            type="button"
          >
            ✕
          </button>
        </div>

        {/* Categories */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">

          {giftCategories.map((cat) => {
            const IconComponent = cat.Icon;
            const isSelected = selectedCategories.includes(cat.slug);

            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => handleCategoryToggle(cat.slug)}
                className={`p-4 sm:p-6 rounded-2xl border-2 transition-all text-left ${isSelected
                  ? "border-accent-500 bg-accent-50 shadow-md"
                  : "border-neutral-200 hover:border-accent-300 bg-white"
                  }`}
              >
                <div className="flex items-center gap-3">
                  <div
                    className={`w-12 h-12 rounded-xl flex items-center justify-center ${isSelected ? "bg-accent-500" : "bg-neutral-100"
                      }`}
                  >
                    {IconComponent && (
                      <IconComponent
                        className={`w-6 h-6 ${isSelected ? "text-white" : "text-neutral-600"
                          }`}
                        strokeWidth={1.5}
                      />
                    )}
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-neutral-900">{cat.name}</p>
                  </div>
                  {isSelected && <div className="text-accent-500 text-2xl">✓</div>}
                </div>
              </button>
            );
          })}
        </div>

        {/* Slider */}
        {selectedCategories.length > 0 && (
          <div className="mt-6 bg-neutral-50 border border-neutral-200 rounded-xl p-5">
            <p className="text-sm text-neutral-900 mb-3">
              <strong>Categorías seleccionadas:</strong> {selectedCategories.length}
            </p>

            <div className="flex items-center gap-4">
              <label className="text-sm font-medium text-neutral-700">
                Regalos por categoría:
              </label>

              <input
                type="range"
                min="3"
                max={maxItemsAvailable}
                value={itemsPerCategory}
                onChange={(e) => setItemsPerCategory(parseInt(e.target.value))}
                className="flex-1"
              />

              <span className="text-lg font-bold text-neutral-900 min-w-[3ch]">
                {itemsPerCategory}
              </span>
            </div>

            <p className="text-xs text-neutral-600 mt-2">
              Se agregarán aproximadamente{" "}
              <strong>{selectedCategories.length * itemsPerCategory} regalos</strong> a tu lista
            </p>
          </div>
        )}

      
        <div className="flex flex-col sm:flex-row gap-3 pt-4 sm:pt-6">
          <button
            type="button"
            onClick={onSkip}
            className="flex-1 btn-secondary py-3 sm:py-4"
          >
            {hasGifts ? "Cancelar" : "Empezar con lista vacía"}
          </button>
          {!hasGifts && (
            <button
              type="button"
              onClick={handleAddRandomGifts}
              disabled={loading}
              className={`flex-1 btn-secondary py-3 sm:py-4 ${loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
            >
              🎲 Sorprendeme
            </button>
          )}

          <button
            type="button"
            onClick={handleAddGifts}
            disabled={selectedCategories.length === 0 || loading}
            className={`flex-1 btn-primary py-3 sm:py-4 ${selectedCategories.length === 0 || loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
          >
            {loading
              ? "Agregando regalos..."
              : hasGifts
                ? "Agregar más regalos"
                : `Agregar ${selectedCategories.length * itemsPerCategory} regalos`}
          </button>
        </div>
{loading && (
  <div className="absolute inset-0 z-50 rounded-2xl bg-white/70 backdrop-blur-sm flex items-center justify-center">
    <div className="bg-white border border-neutral-200 shadow-lg rounded-2xl px-6 py-5 text-center">
      <div className="mx-auto mb-3 h-10 w-10 rounded-full border-4 border-neutral-200 border-t-accent-500 animate-spin" />
      <p className="font-semibold text-neutral-900">Agregando regalos…</p>
      <p className="text-sm text-neutral-600 mt-1">Esto puede tardar unos segundos.</p>
    </div>
  </div>
)}

      </div>
    </div>
  );

};

export default OnboardingWizard;